import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditTransport() {
  const history = useHistory();
  const classes = useStyles();

  const [groupData, setGroupData] = useState([]);
  const [forward_data, setForwardData] = useState([]);
  const [transport_data, setTransport_data] = useState([]);

  const [group, setGroup] = useState("");
  const EmpId = localStorage.getItem("EmpId");
  let { id } = useParams();
  const data_params = { id: id };

  const SelectGroup = (event) => {
    setGroup(event.target.value);
  };

  const FetchGroup = async () => {
    try {
      const data = await api.get("api/master/group");
      setGroupData(data.data.data);

      //   console.log(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Department
  const getForwarder = async () => {
    try {
      const data = await api.get("api/master/company");
      //   console.log(data.data);
      setForwardData(data.data?.data);
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Data

  const getData = async () => {
    try {
      const data = await api
        .post("api/transport/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              console.log(res);
              setTransport_data(res);
              setGroup(res.GroupId);
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Employee");
                }
              });
            });
            // console.log("Nodata" + response);
          }
          //   console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getData();
    FetchGroup();
    getForwarder();
  }, []);
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ขนส่ง
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Transport
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Transport
            </Typography>
          </Grid>
        </Grid>

        <Formik
          enableReinitialize
          initialValues={{
            transport_code: transport_data.TransportNo,
            transport_name: transport_data.TransportName,
            transport_compapny: transport_data.CompanyId
              ? transport_data.CompanyId
              : "",
            status: transport_data.Status
              ? transport_data.Status === true ? 1 : 0
              : 0,
            cntr: "",
            tuns: 0,
          }}
          validate={(values) => {
            const errors = {};
            if (!values.transport_code || values.transport_code === "") {
              errors.transport_code = "Required";
            }
            if (!values.transport_name || values.pol_no === "") {
              errors.transport_name = "Required";
            }
            if (
              !values.transport_compapny ||
              values.transport_compapny === ""
            ) {
              errors.transport_compapny = "Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                id: transport_data.TransportId,
                groupId: group,
                no: values.transport_code,
                name: values.transport_name,
                companyId: values.transport_compapny,
                status: values.status,
                ModId: EmpId,
              };

              api
                .post("api/transport/update", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "แก้ไขขนส่งสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/Transport");
                      }
                    });
                  });
                  console.log(respose);
                })
                .catch((err) => {
                  console.log(err);
                });
              // alert(JSON.stringify(data, null, 2));
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <Grid item xs={12}>
                <FormControl fullWidth required classes={{ root: !group ? classes.customOutline : null }}>
                  <InputLabel>กลุ่มการขนส่ง</InputLabel>
                  <Select
                    value={group ? group : ""}
                    onChange={SelectGroup}
                    label="กลุ่มการขนส่ง"
                    style={{
                      width: "50%",
                      // marginTop: "10px",
                    }}
                  >
                    {groupData.map((option) => {
                      return (
                        <MenuItem key={option.GroupId} value={option.GroupId}>
                          {option.GroupName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid container>
                <Grid item xs={4} sm={4} md>
                  <div>
                    <TextField
                      name="transport_code"
                      label="รหัสการขนส่ง"
                      variant="outlined"
                      placeholder="รหัสการขนส่ง"
                      style={{
                        width: "50%",
                        marginTop: "10px",
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputLabelProps={{ shrink: true }}
                      value={values.transport_code}
                      classes={{ root: !values.transport_code ? classes.customOutline : null }}
                      required
                    />
                    {/* {errors.transport_code &&
                      touched.transport_code &&
                      errors.transport_code} */}
                  </div>
                  <div>
                    <TextField
                      label="การขนส่ง"
                      InputLabelProps={{ shrink: true }}
                      placeholder="การขนส่ง"
                      name="transport_name"
                      style={{
                        width: "50%",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.transport_name}
                      classes={{ root: !values.transport_name ? classes.customOutline : null }}
                      required
                    />
                    {/* {errors.transport_name &&
                      touched.transport_name &&
                      errors.transport_name} */}
                  </div>

                  <div style={{ display: "flex", marginTop: 10 }}>
                    <FormControl
                      sx={{
                        width: "50%",
                        marginBottom: "10px",
                      }}
                    >
                      <InputLabel>บริษัทขนส่ง</InputLabel>
                      <Select
                        name="transport_compapny"
                        label="บริษัทขนส่ง"
                        value={values.transport_compapny}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="" disabled>
                          <em>เลือก บริษัทขนส่ง</em>
                        </MenuItem>
                        {forward_data.map((option, index) => {
                          return (
                            <MenuItem key={index} value={option.CompanyId}>
                              {option.CompanyName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </div>

                  <div style={{ display: "flex", marginTop: 10 }}>
                    <FormControl
                      sx={{
                        width: "50%",
                        marginBottom: "10px",
                      }}
                    >
                      <InputLabel>สถานะ</InputLabel>
                      <Select
                        name="status"
                        label="สถานะ"
                        value={values.status}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="" disabled>
                          <em>เลือก สถานะ</em>
                        </MenuItem>
                        <MenuItem value={1}>Active</MenuItem>
                        <MenuItem value={0}>InActive</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  {/* <div>
                    <TextField
                      label="CNTR Capacity"
                      InputLabelProps={{ shrink: true }}
                      placeholder="CNTR Capacity"
                      name="cntr"
                      style={{
                        width: "50%",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.cntr}
                    />
                    {errors.cntr && touched.cntr && errors.cntr}
                  </div> */}
                  {/* <div>
                    <TextField
                      label="จำนวน (ตัน)"
                      InputLabelProps={{ shrink: true }}
                      placeholder="จำนวน (ตัน)"
                      name="tuns"
                      style={{
                        width: "50%",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.tuns}
                    />
                    {errors.tuns && touched.tuns && errors.tuns}
                  </div> */}
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
